import { h, Host } from "@stencil/core";
export class GxgBox {
    constructor() {
        this.background = "white";
        this.border = true;
        this.padding = "xs";
        this.minHeight = "auto";
        this.height = "auto";
        this.maxWidth = "100%";
    }
    /*********************************
    METHODS
    *********************************/
    render() {
        return (h(Host, { role: "article", class: {
                card: true,
                border: this.border,
            }, style: {
                maxWidth: this.maxWidth,
                minHeight: this.minHeight,
                height: this.height,
            } }, h("div", { class: "container" }, h("slot", null))));
    }
    static get is() { return "gxg-box"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["box.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["box.css"]
        };
    }
    static get properties() {
        return {
            "background": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "background",
                    "resolved": "\"gray-01\" | \"gray-02\" | \"white\"",
                    "references": {
                        "background": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/box/box.tsx",
                            "id": "src/components/box/box.tsx::background"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The background color"
                },
                "attribute": "background",
                "reflect": true,
                "defaultValue": "\"white\""
            },
            "border": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Wether the box has border or not"
                },
                "attribute": "border",
                "reflect": false,
                "defaultValue": "true"
            },
            "padding": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "padding",
                    "resolved": "\"0\" | \"l\" | \"m\" | \"s\" | \"xl\" | \"xs\" | \"xxl\" | \"xxxl\"",
                    "references": {
                        "padding": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/box/box.tsx",
                            "id": "src/components/box/box.tsx::padding"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The box padding"
                },
                "attribute": "padding",
                "reflect": true,
                "defaultValue": "\"xs\""
            },
            "minHeight": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The component min. height"
                },
                "attribute": "min-height",
                "reflect": false,
                "defaultValue": "\"auto\""
            },
            "height": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The component  height"
                },
                "attribute": "height",
                "reflect": false,
                "defaultValue": "\"auto\""
            },
            "maxWidth": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The component max. width"
                },
                "attribute": "max-width",
                "reflect": false,
                "defaultValue": "\"100%\""
            }
        };
    }
}
//# sourceMappingURL=box.js.map
